import { Icon } from '@perch-labs/shrike';
import { ReactElement } from 'react';
import { Link } from '~/components/link';
import { Separator } from '~/components/separator';
import { Text } from '~/components/typography';
import { useDialog } from '~/hooks';
import { theme as lightMode } from '~/styles';
import { TRACK, trackEvent } from '~/utils/tracking';
import { StyledModal as Dialog } from '../dialog.style';
import { ContactMethodContainer } from './help.style';

interface Props {
  isSmb?: boolean;
  phoneNumber?: string;
  target: ReactElement;
}

export const PerchHelpDialog = ({ isSmb = false, phoneNumber = '888-893-3633', target }: Props) => {
  const { isOpen, close, TargetComponent } = useDialog(target);
  const email = 'customercare@perchenergy.com';

  return (
    <>
      {TargetComponent}
      <Dialog aria-label="Help Dialog" isOpen={isOpen} onDismiss={close} theme={lightMode}>
        <Dialog.HeaderCentered title="Our team is here to help" onClose={close} />
        <Text textAlign="center" paddingTop={16} px={5}>
          The Perch Support team is happy to answer any questions you have. We’re available Monday
          to Friday,
        </Text>
        <Text textAlign="center" paddingBottom={16} px={5}>
          8:00 am to 7:00 pm ET
        </Text>
        <ContactMethodContainer>
          <Text textAlign="center" paddingBottom="32px">
            Email us and we'll get back to you as soon as possible.
          </Text>
          <Link
            onClick={() => trackEvent(TRACK.supportLinkClicked)}
            openInNewTab
            color="primary"
            fullWidth
            hideIcon
            href={`mailto:${email}`}
            type="CTA"
          >
            <Icon style={{ marginRight: '10px' }} icon="Envelope" color="primaryInverse" />
            Email us
          </Link>
        </ContactMethodContainer>
        {!isSmb && (
          <>
            <Separator innerText="or" py={0} paddingLeft="32px" paddingRight="32px" />
            <ContactMethodContainer>
              <Text textAlign="center">
                <Icon icon="Phone" color="accent9" margin={{ right: '8px' }} /> Call us at{' '}
                <Link
                  color="primary"
                  href={`tel:1-${phoneNumber}`}
                  track={TRACK.supportLinkClicked}
                >
                  {phoneNumber}
                </Link>
                .
              </Text>
            </ContactMethodContainer>
          </>
        )}
      </Dialog>
    </>
  );
};
